import React from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import Button from "../components/shared/button";
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from "react-i18next";

const LogoutModal = ({ isModalOpen, setIsModalOpen }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content flex flex-col items-center p-[34px] gap-[24px]">
          <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
            {t("adminDashboard.logout.title")}
          </h5>
          <div className="flex gap-[8px]">
            <Button
              text={t("adminDashboard.logout.yes")}
              className="button btn-blue-border rounded-[39px] large"
              height={45}
              width={142}
              onClick={() => {
                secureLocalStorage.removeItem("loginCredentials");
                navigate("/");
              }}
            />

            <Button
              text={t("adminDashboard.logout.no")}
              className="button btn-blue !rounded-[39px] large"
              height={45}
              width={142}
              onClick={handleCancel}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LogoutModal;
